import { ActiveMessagesConstants } from '../../ActiveMessagesConstants';
import { GROWTH_ACTIVE_MESSAGE_WA_SEND_STEP_STARTED, GROWTH_ACTIVE_MESSAGE_WA_RESPONSE_STEP_FLOW_SELECTED, } from '../../../GrowthSegmentEvents';
import { CampaignType } from '../../models/CampaignType';
import { isNullOrWhiteSpace } from 'data/string';
import { RedirectType } from '../../models/RedirectType';
import { convertToDataOptions, convertToArray, } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/outputs/components/outputStateCard/outputStateCard.component';
export class ResponseTargetingStepComponentBase {
    static $inject = ['ActiveMessageServiceParent', 'ContextProcessorServiceParent', 'LoadingServiceParent', 'BuilderServiceParent', 'HostingServiceParent', 'ApplicationService2Parent', 'BlipToastServiceParent', 'GrowthSegmentServiceParent', '$translateParent', 'AlertServiceParent'];
    constructor(ActiveMessageServiceParent, ContextProcessorServiceParent, LoadingServiceParent, BuilderServiceParent, HostingServiceParent, ApplicationService2Parent, BlipToastServiceParent, GrowthSegmentServiceParent, $translateParent, AlertServiceParent) {
        'ngInject';
        this.ActiveMessageServiceParent = ActiveMessageServiceParent;
        this.ContextProcessorServiceParent = ContextProcessorServiceParent;
        this.LoadingServiceParent = LoadingServiceParent;
        this.BuilderServiceParent = BuilderServiceParent;
        this.HostingServiceParent = HostingServiceParent;
        this.ApplicationService2Parent = ApplicationService2Parent;
        this.BlipToastServiceParent = BlipToastServiceParent;
        this.GrowthSegmentServiceParent = GrowthSegmentServiceParent;
        this.$translateParent = $translateParent;
        this.AlertServiceParent = AlertServiceParent;
        this.changeTargetParent = async (value) => {
            this.stateId = value;
            this.agentEmail = '';
        };
        this.changeAgentEmail = async (event) => {
            this.isAgentEmailValid = await event.srcElement.isValid();
            this.agentEmail = event.detail?.value;
            this.errorAttendance = undefined;
        };
        this.isInvalidAgent = () => !isNullOrWhiteSpace(this.errorAttendance);
        this.filterStates = (arr) => {
            if (this.isAttendanceRedirect == RedirectType.Agent) {
                return arr.value.startsWith('desk:');
            }
            return true;
        };
        this.generateStatesDataOptions = (data) => {
            return convertToArray(data).map(convertToDataOptions).filter(this.filterStates);
        };
        this.checkIfRedirectIsAllowedBase = () => this.campaignType == CampaignType.Individual || this.campaignType == CampaignType.Group;
        this.handleNextStep = async (getState, getDataInternal, isWhatsAppGroup = false, isAiAgent = false) => {
            let stateId = this.stateId;
            let stateValue;
            if (isWhatsAppGroup || isAiAgent) {
                const $data = await this.composeResponseTargetingData(getDataInternal, stateValue);
                this.trackResponseTargetingConfiguration(stateId);
                this.callback({ $data });
                this.next();
                return;
            }
            if (!stateId) {
                this.stateId = stateId = ActiveMessagesConstants.ONBOARDING_STATE;
            }
            this.trackResponseTargetingConfiguration(stateId);
            const state = getState();
            stateValue = state.$title;
            const $data = await this.composeResponseTargetingData(getDataInternal, stateValue);
            this.callback({ $data });
            this.next();
        };
        this.HELPCENTER_PAGE_LINK = ActiveMessagesConstants.HELPCENTER_PAGE_URI;
        this.isAttendanceRedirect = RedirectType.Flow;
    }
    async initialize() {
        this.application = JSON.parse(this.parent);
        this.isDeskIdInStateFlow = true;
        await this.loadTranslations();
        this.isBotRouter = String(this.isBotRouter) == 'true';
    }
    async loadTranslations() {
        this.errorLoadStatesDescription = await this.$translateParent('activeMessages.send.responseTargeting.errorLoadStatesDescription');
        this.stepName = await this.$translateParent('activeMessages.send.responseTargeting.botFlow');
    }
    checkContinueButton() {
        if (this.checkIfRedirectIsAllowedBase() && this.isAttendanceRedirect === RedirectType.Agent) {
            return this.isAgentEmailValid && !isNullOrWhiteSpace(this.agentEmail) && !isNullOrWhiteSpace(this.stateId);
        }
        return true;
    }
    convertStateItem(flow) {
        return {
            id: flow.shortName,
            name: flow.longName,
        };
    }
    handlePreviousStep() {
        this.previous();
    }
    async continueAction(getState, getData, isWhatsAppGroup, isAiAgent) {
        if (isWhatsAppGroup || isAiAgent) {
            return this.handleNextStep(getState, getData, isWhatsAppGroup, isAiAgent);
        }
        if (this.checkContinueButton()) {
            if (!this.stateId || typeof this.stateId === 'undefined') {
                await this.showEmptyFlowIdAlert(getState, getData);
            }
            else {
                this.handleNextStep(getState, getData, isWhatsAppGroup, isAiAgent);
            }
        }
    }
    async checkIfDeskIdIsInStateFlow(list) {
        const flowDesk = list.find(element => element.id.startsWith('desk:'));
        return !isNullOrWhiteSpace(flowDesk?.id);
    }
    async setRedirectTypeParent(value) {
        this.isAttendanceRedirect = RedirectType[value];
        this.stateId = undefined;
        this.agentEmail = '';
        if (value == RedirectType.Flow) {
            this.labelBotState = await this.$translateParent('activeMessages.send.responseTargeting.select.labelState');
        }
        else if (value == RedirectType.Agent) {
            this.labelBotState = await this.$translateParent('activeMessages.send.responseTargeting.select.labelAgentState');
        }
    }
    trackSelectedFlow(type) {
        this.GrowthSegmentServiceParent.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_RESPONSE_STEP_FLOW_SELECTED, {
            botType: type,
            activeMessageType: this.campaignType,
        });
    }
    async showEmptyFlowIdAlert(getState, getData) {
        const alertTitle = await this.$translateParent('activeMessages.send.responseTargeting.alert.title');
        const alertBody = await this.$translateParent('activeMessages.send.responseTargeting.alert.body');
        const cancelButton = await this.$translateParent('utils.forms.back');
        const confirmButton = await this.$translateParent('activeMessages.send.responseTargeting.alert.retry');
        await this.AlertServiceParent.show({
            title: alertTitle,
            body: alertBody,
            variant: 'warning',
            icon: 'attention',
            buttons: {
                cancel: cancelButton,
                confirm: confirmButton,
            },
            callback: {
                cancelButtonAction: () => { },
                confirmButtonAction: () => this.handleNextStep(getState, getData),
            },
        });
    }
    async composeResponseTargetingData(getDataInternal, stateValue) {
        const $data = getDataInternal();
        if (this.isAttendanceRedirect == RedirectType.Agent) {
            $data.name = await this.$translateParent('activeMessages.send.responseTargeting.redirect.agent');
        }
        if (this.isBotRouter) {
            $data.value.push({
                name: await this.$translateParent('activeMessages.send.responseTargeting.redirect.radio.flow'),
                description: stateValue,
            });
        }
        if (this.checkIfRedirectIsAllowedBase() && this.isAttendanceRedirect == RedirectType.Agent && this.isAgentEmailValid) {
            $data.params.attendanceRedirect = this.agentEmail;
            $data.value.push({
                name: await this.$translateParent('activeMessages.send.responseTargeting.redirect.agent'),
                description: this.agentEmail,
            });
        }
        else if (!this.isBotRouter) {
            $data.value.push({
                description: stateValue,
            });
        }
        return $data;
    }
    trackResponseTargetingConfiguration(stateId) {
        this.GrowthSegmentServiceParent.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_SEND_STEP_STARTED, {
            activeMessageType: this.campaignType,
            redirectType: this.isAttendanceRedirect == 'Flow' ? RedirectType.Flow : RedirectType.Agent,
            agentName: this.isAttendanceRedirect == 'Flow' ? '' : this.agentEmail,
            stateId: stateId,
        });
    }
}
ResponseTargetingStepComponentBase.$inject = ['ActiveMessageServiceParent', 'ContextProcessorServiceParent', 'LoadingServiceParent', 'BuilderServiceParent', 'HostingServiceParent', 'ApplicationService2Parent', 'BlipToastServiceParent', 'GrowthSegmentServiceParent', '$translateParent', 'AlertServiceParent'];
